import React from 'react';
import { useNavigate } from 'react-router-dom';

function AboutUsSection() {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate('/about');
  };

  return (
    <section className="aboutus-section">
      <div className="aboutus-bg" style={{ backgroundImage: "url('/images/products/background-about.png')" }}>
        <div className="aboutus-overlay">
          <h2 className="aboutus-title">About Us</h2>
          <div className="aboutus-desc">
            Deepak Plywood & Timbers is more than a name; it's a mark of trust and quality in the timber and plywood industry. With a skilled team and a commitment to affordable excellence, we offer products crafted for durability and performance. Our dedication to providing only the best ensures every customer walks away with materials they can rely on—and a project built to last. From expert guidance to award-winning service, we make your building journey seamless and successful.
          </div>
          <button className="aboutus-btn" onClick={handleReadMore}>READ MORE</button>
        </div>
      </div>
    </section>
  );
}

export default AboutUsSection; 